export default __webpack_public_path__ + "static/media/nativeAmerican.65ffdaa9.png";